import PodcastView from './PodcastView';

export default PodcastView;
